import { format, isSameDay, isToday, isYesterday } from 'date-fns';
import type { Conversation, MessagingUser } from './api';

export function otherParticipants(conversation: Conversation, currentUserId: number): MessagingUser[] {
  return conversation.participants.filter((p) => p.id !== currentUserId);
}

export function conversationLabel(conversation: Conversation, currentUserId: number): string {
  const others = otherParticipants(conversation, currentUserId);
  if (others.length === 0) return 'You';
  return others.map((p) => `${p.first_name} ${p.last_name}`).join(', ');
}

export function conversationTimeLabel(iso: string): string {
  const d = new Date(iso);
  if (isToday(d)) return format(d, 'h:mm a');
  if (isYesterday(d)) return 'Yesterday';
  return format(d, d.getFullYear() === new Date().getFullYear() ? 'MMM d' : 'MMM d, yyyy');
}

export function messageDateLabel(iso: string): string {
  const d = new Date(iso);
  if (isToday(d)) return 'Today';
  if (isYesterday(d)) return 'Yesterday';
  return format(d, d.getFullYear() === new Date().getFullYear() ? 'MMMM d' : 'MMMM d, yyyy');
}

export function messageTimeLabel(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export function isNewDay(currentIso: string, previousIso: string | undefined): boolean {
  if (previousIso == null) return true;
  return !isSameDay(new Date(currentIso), new Date(previousIso));
}
